import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _createClass from "@babel/runtime/helpers/createClass";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import SelectorSpec from "./SelectorSpec";
import idArgSelector from "./idArgSelector";

var ModelSelectorSpec = /*#__PURE__*/function (_SelectorSpec) {
  _inheritsLoose(ModelSelectorSpec, _SelectorSpec);

  function ModelSelectorSpec(_ref) {
    var _this;

    var model = _ref.model,
        other = _objectWithoutProperties(_ref, ["model"]);

    _this = _SelectorSpec.call(this, other) || this;
    _this._model = model;
    return _this;
  }

  _createClass(ModelSelectorSpec, [{
    key: "key",
    get: function get() {
      return this._model.modelName;
    }
  }, {
    key: "dependencies",
    get: function get() {
      return [this._orm, idArgSelector];
    }
  }, {
    key: "resultFunc",
    get: function get() {
      var _this2 = this;

      return function (_ref2, idArg) {
        var ModelClass = _ref2[_this2._model.modelName];

        if (typeof idArg === "undefined") {
          return ModelClass.all().toRefArray();
        }

        if (Array.isArray(idArg)) {
          return idArg.map(function (id) {
            var instance = ModelClass.withId(id);
            return instance ? instance.ref : null;
          });
        }

        var instance = ModelClass.withId(idArg);
        return instance ? instance.ref : null;
      };
    }
  }, {
    key: "model",
    get: function get() {
      return this._model;
    }
  }]);

  return ModelSelectorSpec;
}(SelectorSpec);

export { ModelSelectorSpec as default };